import { useEffect, useState } from "react";
import axios from "axios";
import { Api } from "../networks/Api";

const useFetchBrandList = (token, initialData = []) => {
  const normalizedInitialData = Array.isArray(initialData)
    ? initialData
    : Object.values(initialData || {}).map((name) => ({ name }));
  const [brandData, setBrandData] = useState(normalizedInitialData);
  const hasInitialData = normalizedInitialData.length > 0;

  useEffect(() => {
    const fetchBrandData = async () => {
      if (hasInitialData) return;

      try {
        const response = await axios.get(
          Api.getFeedBrandList,
          Api.Header(token)
        );
        if (response.status === 200) setBrandData(response.data.data);
      } catch (e) {
        console.error("Error fetching brand data:", e);
      }
    };

    fetchBrandData();
  }, [token, hasInitialData]);

  return brandData;
};

export default useFetchBrandList;
